<template>
  <el-dialog
    custom-class="qrcode-dialog"
    :title="title"
    :visible="isShowDialog"
    :width="`${width}px`"
    @close="closeDialog"
  >
    <div class="applicable-dialog">
      <img :class="[`applicable-qrcode--${qrcodeSize}`]" :src="qrcodeUrl" />
      <div class="text">{{ preText }}</div>
      <div class="applicable-dialog-text text">{{ subText }}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    isShowDialog: Boolean,
    qrcodeUrl: {
      type: String,
      default: require('@/assets/images/header/appEenterence-qrcode.png')
    },
    qrcodeSize: {
      type: String,
      default: 'middle',
      validator: val => ['middle', 'small'].includes(val)
    },
    width: {
      type: Number,
      default: 500
    },
    preText: String,
    subText: String
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="scss">
.qrcode-dialog {
  .el-dialog__header {
    text-align: left;
    padding-top: 16px !important;
  }
}
</style>

<style lang="scss" scoped>
.applicable-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    top: -15px;
    display: block;
    border-top: 1px #e5e5e5 solid;
  }

  .applicable-qrcode--middle {
    width: 230px;
    height: 230px;
  }

  .applicable-qrcode--small {
    width: 200px;
    height: 200px;
    margin: 10px;
  }

  .applicable-dialog-text {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  .text {
    text-align: center;
    white-space: pre-wrap;
  }
}
</style>
